"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecretWasmService = void 0;
const tsyringe_1 = require("tsyringe");
const types_1 = require("../types");
const secretjs_1 = require("secretjs");
const keyring_1 = require("../keyring");
const chains_1 = require("../chains");
const permission_1 = require("../permission");
const crypto_1 = require("@keplr-wallet/crypto");
const common_1 = require("@keplr-wallet/common");
const cosmos_1 = require("@keplr-wallet/cosmos");
const buffer_1 = require("buffer/");
let SecretWasmService = class SecretWasmService {
    constructor(kvStore, chainsService, keyRingService, permissionService) {
        this.kvStore = kvStore;
        this.chainsService = chainsService;
        this.keyRingService = keyRingService;
        this.permissionService = permissionService;
        this.debouncerMap = new Map();
        this.cacheEnigmaUtils = new Map();
        this.onChainRemoved = () => {
            this.cacheEnigmaUtils = new Map();
        };
        this.chainsService.addChainRemovedHandler(this.onChainRemoved);
    }
    getPubkey(env, chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            const chainInfo = yield this.chainsService.getChainInfo(chainId);
            const keyRingType = yield this.keyRingService.getKeyRingType();
            if (keyRingType === "none") {
                throw new Error("Key ring is not initialized");
            }
            const seed = yield this.getSeed(env, chainInfo);
            const utils = this.getEnigmaUtils(chainInfo, seed);
            return utils.pubkey;
        });
    }
    getTxEncryptionKey(env, chainId, nonce) {
        return __awaiter(this, void 0, void 0, function* () {
            const chainInfo = yield this.chainsService.getChainInfo(chainId);
            const keyRingType = yield this.keyRingService.getKeyRingType();
            if (keyRingType === "none") {
                throw new Error("Key ring is not initialized");
            }
            const seed = yield this.getSeed(env, chainInfo);
            const utils = this.getEnigmaUtils(chainInfo, seed);
            return utils.getTxEncryptionKey(nonce);
        });
    }
    encrypt(env, chainId, contractCodeHash, 
    // eslint-disable-next-line @typescript-eslint/ban-types
    msg) {
        return __awaiter(this, void 0, void 0, function* () {
            const chainInfo = yield this.chainsService.getChainInfo(chainId);
            const keyRingType = yield this.keyRingService.getKeyRingType();
            if (keyRingType === "none") {
                throw new Error("Key ring is not initialized");
            }
            // XXX: Keplr should generate the seed deterministically according to the account.
            // Otherwise, it will lost the encryption/decryption key if Keplr is uninstalled or local storage is cleared.
            // For now, use the signature of some string to generate the seed.
            // It need to more research.
            const seed = yield this.getSeed(env, chainInfo);
            const utils = this.getEnigmaUtils(chainInfo, seed);
            return yield utils.encrypt(contractCodeHash, msg);
        });
    }
    decrypt(env, chainId, ciphertext, nonce) {
        return __awaiter(this, void 0, void 0, function* () {
            const chainInfo = yield this.chainsService.getChainInfo(chainId);
            const keyRingType = yield this.keyRingService.getKeyRingType();
            if (keyRingType === "none") {
                throw new Error("Key ring is not initialized");
            }
            // XXX: Keplr should generate the seed deterministically according to the account.
            // Otherwise, it will lost the encryption/decryption key if Keplr is uninstalled or local storage is cleared.
            // For now, use the signature of some string to generate the seed.
            // It need to more research.
            const seed = yield this.getSeed(env, chainInfo);
            const utils = this.getEnigmaUtils(chainInfo, seed);
            return yield utils.decrypt(ciphertext, nonce);
        });
    }
    getEnigmaUtils(chainInfo, seed) {
        const key = `${chainInfo.chainId}-${buffer_1.Buffer.from(seed).toString("hex")}`;
        if (this.cacheEnigmaUtils.has(key)) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return this.cacheEnigmaUtils.get(key);
        }
        // TODO: Handle the rest config.
        const utils = new secretjs_1.EnigmaUtils(chainInfo.rest, seed);
        this.cacheEnigmaUtils.set(key, utils);
        return utils;
    }
    // GetSeed will be debounced if the prior promise is pending.
    // GetSeed can be occured multiple times at once,
    // this case can be problem if the cache doesn't exist and key type is ledger,
    // because multiple requests to ledger will make the connection unstable.
    getSeed(env, chainInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            const key = yield this.keyRingService.getKey(chainInfo.chainId);
            const bech32Address = new cosmos_1.Bech32Address(key.address).toBech32(chainInfo.bech32Config.bech32PrefixAccAddr);
            const debouncerKey = `${env.isInternalMsg}/${chainInfo.chainId}/${bech32Address}`;
            if (!this.debouncerMap.has(debouncerKey)) {
                this.debouncerMap.set(debouncerKey, common_1.Debouncer.promise(this.getSeedInner.bind(this)));
            }
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const debouncedFn = this.debouncerMap.get(debouncerKey);
            return yield debouncedFn(env, chainInfo, bech32Address);
        });
    }
    getSeedInner(env, chainInfo, bech32Address) {
        return __awaiter(this, void 0, void 0, function* () {
            const storeKey = `seed-${chainInfo.chainId}-${bech32Address}`;
            const cached = yield this.kvStore.get(storeKey);
            if (cached) {
                return buffer_1.Buffer.from(cached, "hex");
            }
            const seed = crypto_1.Hash.sha256(buffer_1.Buffer.from(yield this.keyRingService.sign(env, chainInfo.chainId, buffer_1.Buffer.from(JSON.stringify({
                account_number: 0,
                chain_id: chainInfo.chainId,
                fee: [],
                memo: "Create Keplr Secret encryption key. Only approve requests by Keplr.",
                msgs: [],
                sequence: 0,
            })))));
            yield this.kvStore.set(storeKey, buffer_1.Buffer.from(seed).toString("hex"));
            return seed;
        });
    }
};
SecretWasmService = __decorate([
    tsyringe_1.singleton(),
    __param(0, tsyringe_1.inject(types_1.TYPES.SecretWasmStore)),
    __param(1, tsyringe_1.inject(chains_1.ChainsService)),
    __param(2, tsyringe_1.inject(tsyringe_1.delay(() => keyring_1.KeyRingService))),
    __param(3, tsyringe_1.inject(tsyringe_1.delay(() => permission_1.PermissionService))),
    __metadata("design:paramtypes", [Object, chains_1.ChainsService,
        keyring_1.KeyRingService,
        permission_1.PermissionService])
], SecretWasmService);
exports.SecretWasmService = SecretWasmService;
//# sourceMappingURL=service.js.map